import React from "react";
import styles from "./BetTableTeenJoker.module.css";
// Import card suit icons
import spadeIcon from '../../../../assets/img/cardsIcons/spade.png';
import clubIcon from '../../../../assets/img/cardsIcons/club.png';
import heartIcon from '../../../../assets/img/cardsIcons/heart.png';
import diamondIcon from '../../../../assets/img/cardsIcons/diamond.png';

const BetTableTeenJoker = ({ data = [], onBetClick, exposures = {}, min = "100.0", max = "100K" }) => {
  
  // Get exposure value - try different key formats
  const getExposure = (selection) => {
    const exposureKeys = [
      selection,
      selection?.toLowerCase(),
      selection?.trim(),
      selection?.replace(/\s+/g, ' ').trim(),
    ];

    let exposure = 0;
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined && exposures[key] !== null) {
        const expValue = parseFloat(exposures[key]);
        if (!isNaN(expValue)) {
          exposure = expValue;
          break;
        }
      }
    }

    return exposure;
  };

  // Find data items from sub array
  const playerA = data.find(item => item?.nat === "Player A") || {};
  const playerB = data.find(item => item?.nat === "Player B") || {};
  const jokerEven = data.find(item => item?.nat === "Joker Even") || {};
  const jokerOdd = data.find(item => item?.nat === "Joker Odd") || {};
  const jokerRed = data.find(item => item?.nat === "Joker Red") || {};
  const jokerBlack = data.find(item => item?.nat === "Joker Black") || {};
  const jokerSpade = data.find(item => item?.nat === "Joker Spade") || {};
  const jokerHeart = data.find(item => item?.nat === "Joker Heart") || {};
  const jokerDiamond = data.find(item => item?.nat === "Joker Diamond") || {};
  const jokerClub = data.find(item => item?.nat === "Joker Club") || {};

  // Check if row should be suspended
  const isRowSuspended = (item) => {
    const value = item?.b ?? 0;
    const gstatus = item?.gstatus?.toUpperCase();
    return value === 0 || value === "0" || value === undefined || value === null || gstatus === "SUSPENDED";
  };

  // Format exposure value
  const formatExposure = (value) => {
    if (value === null || value === undefined || value === 0) return "0";
    if (Math.abs(value) >= 1000) {
      return value < 0 ? value : value;
    }
    return value < 0 ? value : value;
  };

  // Format bet value (show b/l for odds)
  const formatBetValue = (betData, type = "back") => {
    if (type === "back") {
      return betData?.b || "0";
    }
    return betData?.l || "0";
  };

  // Format available amount (show bs/ls)
  const formatAvailableAmount = (betData, type = "back") => {
    if (type === "back") {
      return betData?.bs || "0";
    }
    return betData?.ls || "0";
  };

  // Render player row with BACK and LAY columns
  const renderPlayerRow = (item, playerName) => {
    const rowSuspended = isRowSuspended(item);
    const exposure = getExposure(item?.nat || playerName);

    return (
      <tr key={playerName} data-title={item?.gstatus || "OPEN"} className={rowSuspended ? styles.suspendedRow : ""}>
        <td className={`box-4 player-name`} style={{ padding: '4px 6px', backgroundColor: '#333d79ff', color: 'white' }}>
          <div><b>{playerName}</b></div>
          <span className="d-block" style={{ color: 'white', fontSize: '12px' }}>
            {formatExposure(exposure)}
          </span>
        </td>
        <td
          className={`back text-center box-3 back ${rowSuspended ? styles.suspended : ""}`}
          onClick={() => !rowSuspended && onBetClick && onBetClick(formatBetValue(item, "back"), item?.nat || playerName, "back", item)}
          style={{ 
            cursor: rowSuspended ? 'not-allowed' : 'pointer', 
            position: 'relative',
            backgroundColor: '#72bbef',
            background: '#72bbef'
          }}
        >
          <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
            <span className="d-block text-bold odds">{formatBetValue(item, "back")}</span>
            <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(item, "back")}</span>
          </div>
        </td>
        <td
          className={`back text-center box-3 lay ${rowSuspended ? styles.suspended : ""}`}
          onClick={() => !rowSuspended && onBetClick && onBetClick(formatBetValue(item, "lay"), item?.nat || playerName, "lay", item)}
          style={{ 
            cursor: rowSuspended ? 'not-allowed' : 'pointer', 
            position: 'relative',
            backgroundColor: '#faa9ba',
            background: '#faa9ba'
          }}
        >
          <div className="position-relative d-flex flex-column align-items-center justify-content-center h-100" style={{ minHeight: '40px' }}>
            <span className="d-block text-bold odds">{formatBetValue(item, "lay")}</span>
            <span className="d-block" style={{ fontSize: '10px', color: 'black' }}>{formatAvailableAmount(item, "lay")}</span>
          </div>
        </td>
      </tr>
    );
  };

  // Render joker bet cell
  const renderJokerCell = (item, label, cardIcons = null) => {
    const value = item?.b ?? 0;
    const isLocked = value === 0 || value === "0" || value === undefined || value === null || item?.gstatus?.toUpperCase() === "SUSPENDED";
    const exposure = getExposure(item?.nat || label);
    const displayValue = isLocked ? 0 : value;

    return (
      <div className="col-3" style={{ padding: '2px 4px' }}>
        <div>
          <p className="d-block mb-0 text-center" style={{ marginBottom: '2px', color: 'white' }}>
            {cardIcons ? (
              <span className="card-icon" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
                {cardIcons.map((icon, index) => (
                  <img key={index} src={icon} alt="card icon" className={styles.cardImage} />
                ))}
              </span>
            ) : (
              <b>{label}</b>
            )}
          </p>
          <button
            className={`btn-theme mt-1 ${isLocked ? styles.teenpattiSuspended : ""}`}
            onClick={() => !isLocked && onBetClick && onBetClick(displayValue, item?.nat || label, item)}
            disabled={isLocked}
            style={{ marginTop: '2px', padding: '6px 8px' }}
          >
            {!isLocked && <span>{displayValue}</span>}
          </button>
          <p className="mt-1 mb-0 text-center" style={{ 
            color: 'white', 
            fontSize: '12px',
            fontWeight: 'bold',
            marginTop: '2px' 
          }}>
            {exposure !== 0 ? (exposure < 0 ? exposure : `+${exposure}`) : "0"}
          </p>
        </div>
      </div>
    );
  };

  const formatLimit = (value) => {
    if (typeof value === 'string' && value.includes('K')) return value;
    if (typeof value === 'string') {
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        if (numValue >= 1000) {
          return `${(numValue / 1000)}K`;
        }
        return numValue.toFixed(1);
      }
      return value;
    }
    if (typeof value === 'number') {
      if (value >= 1000) {
        return `${(value / 1000)}K`;
      }
      return value.toFixed(1);
    }
    return "100.0";
  };

  return (
    <div className={styles.teenJoker}>
      <div className={`table-responsive m-t-10 casino-box ${styles.tableResponsive}`}>
        <table className="table table-bordered m-b-0">
          <thead>
            <tr>
              <th style={{ backgroundColor: '#ffffff', background: '#ffffff', padding: '10px' }} className="box-4 min-max">
                <div className="d-block">
                  <div style={{ fontSize: '10px', display: 'flex' }}> Min: <div style={{ fontSize: '10px' }}>{formatLimit(min)}</div></div>
                  <div style={{ fontSize: '10px', display: 'flex' }}> Max: <div style={{ fontSize: '10px' }}>{formatLimit(max)}</div></div>
                </div>
              </th>
              <th style={{ backgroundColor: '#72bbef', background: '#72bbef', padding: '10px' }} className="text-center box-3 Back">BACK</th>
              <th style={{ backgroundColor: '#faa9ba', background: '#faa9ba', padding: '10px' }} className="text-center box-3 lay">LAY</th>
            </tr>
          </thead>
          <tbody>
            {renderPlayerRow(playerA, "Player A")}
            {renderPlayerRow(playerB, "Player B")}
          </tbody>
        </table>
      </div>
{/* 
      <div className={styles.markets}>
        <div className={styles.market6}>
          <div className={styles.betTable}>
            <div className={styles.betTableHeader}>
              <div className={`${styles.nationName} p-2`} style={{ backgroundColor: '#333d79ff', color: 'white' }}>
                <span>Joker</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container-fluid container-fluid-5 m-t-10">
        <div className="row row5">
          {renderJokerCell(jokerEven, "EVEN")}
          {renderJokerCell(jokerOdd, "ODD")}
          {renderJokerCell(jokerRed, "Red", [heartIcon, diamondIcon])}
          {renderJokerCell(jokerBlack, "Black", [spadeIcon, clubIcon])}
          {renderJokerCell(jokerSpade, "Spade", [spadeIcon])}
          {renderJokerCell(jokerHeart, "Heart", [heartIcon])}
          {renderJokerCell(jokerDiamond, "Diamond", [diamondIcon])}
          {renderJokerCell(jokerClub, "Club", [clubIcon])}
        </div>
      </div>
    </div>
  );
};

export default BetTableTeenJoker;

